import React from 'react';
import { Outlet } from 'react-router-dom';
import AnimatedBackground, { ThemeProvider } from '../layout/AnimatedBackground';

// This component serves as a layout wrapper for auth-related pages (login, signup)
// It keeps the animated background consistent when navigating between these pages
function AuthLayout() {
  return (
    <ThemeProvider>
      <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
        {/* Animated background stays consistent across auth views */}
        <AnimatedBackground />
        
        {/* The child route component (Login or Signup) will render here */}
        <Outlet />
      </div>
    </ThemeProvider>
  );
}

export default AuthLayout; 